import React from 'react';

export default function Blog(){
    return(
        <div className='commonbox blog'>
            
            <h1 className='boxheadings'>An Intuitive Experience <br></br>for Blogging</h1>
            <img className='iphone' src= {require('./images/blog_mockup.png')}></img>
            <p className='app'>MERN Stack Application</p><br></br>
            <p className='sw'>MongoDB, Express JS, React JS, Node JS</p>
        </div>
    );
}